<template>
  <div class="modal fade" id="modal-datos-patente" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-geogo-top-left pt-2 pb-2">
          <h5 class="modal-title text-white">Crear {{ entidad }}</h5>
          <button
            type="button"
            class="close text-white"
            data-dismiss="modal"
            aria-label="Cerrar"
            ref="closeModal"
            @click="limpiarForm()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- Formulario de creación de chofer -->
        <div class="modal-body" v-if="entidad == 'Chofer'">
          <div class="form-group">
            <label class="font-weight-bold">Nombres</label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="form_conductor.nombres"
              :class="
                $v.form_conductor.nombres.$invalid ? 'is-invalid' : 'is-valid'
              "
            />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Apellidos</label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="form_conductor.apellidos"
              :class="
                $v.form_conductor.apellidos.$invalid ? 'is-invalid' : 'is-valid'
              "
            />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">DNI</label>
            <input
              type="number"
              class="form-control form-control-sm"
              v-model="form_conductor.numero_documento"
              @keydown="convertirNumeros"
              @paste.prevent
              @keydown.space.prevent
              :class="
                $v.form_conductor.numero_documento.$invalid
                  ? 'is-invalid'
                  : 'is-valid'
              "
            />
          </div>
        </div>
        <div class="modal-body" v-if="entidad == 'Camión'">
          <div class="form-group">
            <label class="font-weight-bold">Placa</label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="form_vehiculo.placa"
              @input="convertirMayusculas('placa', form_vehiculo)"
              @keydown.space.prevent
              :class="
                $v.form_vehiculo.placa.$invalid ? 'is-invalid' : 'is-valid'
              "
            />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Número Interno</label>
            <input
              type="number"
              class="form-control form-control-sm"
              v-model="form_vehiculo.numero_interno"
              @keydown="convertirNumeros"
              @paste.prevent
              @keydown.space.prevent
              :class="
                $v.form_vehiculo.numero_interno.$invalid
                  ? 'is-invalid'
                  : 'is-valid'
              "
            />
          </div>
        </div>
        <div class="modal-body" v-if="entidad == 'Cisterna'">
          <div class="form-group">
            <label class="font-weight-bold">Placa</label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="form_cisterna.placa"
              @input="convertirMayusculas('placa', form_cisterna)"
              @keydown.space.prevent
              :class="
                $v.form_cisterna.placa.$invalid ? 'is-invalid' : 'is-valid'
              "
            />
          </div>
          <div class="form-group">
            <label class="font-weight-bold">Capacidad (Litros)</label>
            <input
              type="number"
              class="form-control form-control-sm"
              v-model="form_cisterna.capacidad_litros"
              @keydown="convertirNumeros"
              @paste.prevent
              @keydown.space.prevent
              :class="
                $v.form_cisterna.capacidad_litros.$invalid
                  ? 'is-invalid'
                  : 'is-valid'
              "
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="consultSave()"
            v-show="validarForm()"
          >
            Guardar
          </button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
export default {
  name: "ModalDatosPatente",
  data() {
    return {
      entidad: "Camión",
      ruta: null,
      form: null,
      pre: null,
      form_vehiculo: {
        empresa_id: 133,
        placa: null,
        tipo_vehiculo_id: 1,
        numero_interno: null,
        pais_id: 3,
        estado: 1,
      },
      form_cisterna: {
        placa: null,
        capacidad_litros: null,
        pais_id: 3,
      },
      form_conductor: {
        estado: 1,
        pais_id: 3,
        nombres: null,
        apellidos: null,
        tipo_documento: 1,
        numero_documento: null,
        categoria_licencia: 3,
      },
    };
  },

  validations: {
    form_conductor: {
      nombres: {
        required,
      },
      apellidos: {
        required,
      },
      numero_documento: {
        required,
      },
    },
    form_vehiculo: {
      placa: {
        required,
      },
      numero_interno: {
        required,
      },
    },
    form_cisterna: {
      placa: {
        required,
      },
      capacidad_litros: {
        required,
      },
    },
  },
  methods: {
    validarForm() {
      let valid = false;
      switch (this.entidad) {
        case "Camión":
          valid = !this.$v.form_vehiculo.$invalid;
          break;
        case "Cisterna":
          valid = !this.$v.form_cisterna.$invalid;
          break;
        case "Chofer":
          valid = !this.$v.form_conductor.$invalid;
          break;
        default:
          valid = false;
          break;
      }
      return valid;
    },

    consultSave() {
      switch (this.entidad) {
        case "Camión":
          this.ruta = "/api/argentina/hojasCarga/createCamion";
          this.form = this.form_vehiculo;
          this.pre = "El";
          this.save();
          break;
        case "Cisterna":
          this.ruta = "/api/argentina/hojasCarga/createCisterna";
          this.form = this.form_cisterna;
          this.pre = "La";
          this.save();
          break;
        case "Chofer":
          this.ruta = "/api/argentina/hojasCarga/createChofer";
          this.form = this.form_conductor;
          this.pre = "El";
          this.save();
          break;
        default:
          break;
      }
    },

    save() {
      this.$parent.cargando = true;
      axios({
        method: "POST",
        url: this.ruta,
        data: this.form,
      })
        .then((response) => {
          this.$refs.closeModal.click();
          this.$parent.cargando = false;
          this.$swal({
            icon: "success",
            title: this.pre + " " + this.entidad + " se guardó exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((error) => {
          this.$parent.cargando = false;
          this.$swal({
            icon: "error",
            title:
              error.response.data.message ||
              "Ocurrió un error, vuelva a intentarlo...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    limpiarForm() {
      this.ruta = null;
      this.form = null;
      this.pre = null;
      this.form_vehiculo = {
        empresa_id: 133,
        placa: null,
        tipo_vehiculo_id: 1,
        numero_interno: null,
        pais_id: 3,
        estado: 1,
      };
      this.form_cisterna = {
        placa: null,
        capacidad_litros: null,
        pais_id: 3,
      };
      this.form_conductor = {
        estado: 1,
        pais_id: 3,
      };
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },

    convertirNumeros(e) {
      const teclasPermitidas = [
        "Backspace",
        "Delete",
        "Tab",
        "ArrowLeft",
        "ArrowRight",
        "Home",
        "End",
      ];

      if (teclasPermitidas.includes(e.key)) {
        return;
      }

      // Solo permitir números
      if (!/^[0-9]$/.test(e.key)) {
        e.preventDefault();
      }
    },

    convertirMayusculas(campo, form) {
      form[campo] = form[campo].toUpperCase().replace(/\s/g, "");
    },
  },
};
</script>
